import { render, staticRenderFns } from "./SearchTable.vue?vue&type=template&id=70a40938&scoped=true&"
import script from "./SearchTable.vue?vue&type=script&lang=js&"
export * from "./SearchTable.vue?vue&type=script&lang=js&"
import style0 from "./SearchTable.vue?vue&type=style&index=0&id=70a40938&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a40938",
  null
  
)

export default component.exports